import React from 'react';
import './TakTillGolvBrands.css';
import logo from '../../../assets/TTGLogoWhite.png';
import image from '../../../assets/ttgimage8.jpg';

const TakTillGolvBrands = () => {
  return (
    <div className="Tak-Till-Golv-Brands-1">
      <img src={image} alt="Tak Till Golv Brands" className="Tak-Till-Golv-Brands-Custom-image" />
      <a href="http://taktillgolv.se/" target="_blank" rel="noopener noreferrer">
        <img src={logo} alt="Tak Till Golv Logo" className="Tak-Till-Golv-Brands-Custom-logo" />
      </a>
    </div>
  );
};

export default TakTillGolvBrands;
